/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Search_Updated_ToInputs */

const en_explorer_search_updated_to = /** @type {(inputs: Explorer_Search_Updated_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updated to`)
};

const fr_explorer_search_updated_to = /** @type {(inputs: Explorer_Search_Updated_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updated to`)
};

const de_explorer_search_updated_to = /** @type {(inputs: Explorer_Search_Updated_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updated to`)
};

const it_explorer_search_updated_to = /** @type {(inputs: Explorer_Search_Updated_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updated to`)
};

const ru_explorer_search_updated_to = /** @type {(inputs: Explorer_Search_Updated_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updated to`)
};

const es_explorer_search_updated_to = /** @type {(inputs: Explorer_Search_Updated_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updated to`)
};

const zh_cn2_explorer_search_updated_to = /** @type {(inputs: Explorer_Search_Updated_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updated to`)
};

const ja_explorer_search_updated_to = /** @type {(inputs: Explorer_Search_Updated_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updated to`)
};

const hi_explorer_search_updated_to = /** @type {(inputs: Explorer_Search_Updated_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updated to`)
};

const pt_pt2_explorer_search_updated_to = /** @type {(inputs: Explorer_Search_Updated_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updated to`)
};

/**
* | output |
* | --- |
* | "Updated to" |
*
* @param {Explorer_Search_Updated_ToInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_search_updated_to = /** @type {((inputs?: Explorer_Search_Updated_ToInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Search_Updated_ToInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_search_updated_to(inputs)
	if (locale === "de") return de_explorer_search_updated_to(inputs)
	if (locale === "it") return it_explorer_search_updated_to(inputs)
	if (locale === "ru") return ru_explorer_search_updated_to(inputs)
	if (locale === "es") return es_explorer_search_updated_to(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_search_updated_to(inputs)
	if (locale === "ja") return ja_explorer_search_updated_to(inputs)
	if (locale === "hi") return hi_explorer_search_updated_to(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_search_updated_to(inputs)
	return en_explorer_search_updated_to(inputs)
});